import { ArrowUp, ArrowDown, Minus } from "lucide-react";

const MovementIcon = ({ movement }) => {
  if (movement === "up") {
    return <ArrowUp className="h-4 w-4 text-emerald-600" strokeWidth={2.5} />;
  }
  if (movement === "down") {
    return <ArrowDown className="h-4 w-4 text-red-500" strokeWidth={2.5} />;
  }
  return <Minus className="h-4 w-4 text-gray-300" strokeWidth={2.5} />;
};

export default MovementIcon;